(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recovery-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRecoveryBenefits() {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sections = document.querySelectorAll('.recovery-benefits');

    sections.forEach(function (section) {
      var animatedEls = section.querySelectorAll('.recovery-benefits__card, .recovery-benefits__product-frame');

      if (prefersReduced || typeof IntersectionObserver === 'undefined') {
        animatedEls.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      animatedEls.forEach(function (el, i) {
        el.style.transitionDelay = (i % 6) * 70 + 'ms';
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecoveryBenefits);
  } else {
    initRecoveryBenefits();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
